export const ALL_NEW_TITLE = 'allnewtitles';
export const HOT_TITLES = 'hotTitles';
export const TOP_POD_TITLES = 'topPodTitles';
export const ALL_EXCLUDED = 'allexcluded';
export const BOOKSTAT_DATA = 'bookstatdata';
export const COMPETITORS = 'competitors';
export const PENDING_EXCLUSION = 'pendingexclusion';
export const PODIUM_SALES = 'podiumsales';
export const PODIUM_TITLES = 'podiumtitles';
export const SEND_TO_CRM = 'sendtocrm';
export const MUTED_AUTHORS = 'mutedAuthors';
export const WATCHLIST = 'watchlist';
export const CONTACTED = 'contacted';
export const DELETE = 'delete';
export const BLOCKAUTHOR = 'blockAuthor';
export const MUTEAUTHOR = 'muteAuthor';
export const UNMUTEAUTHOR = 'unmuteAuthor';
export const RETURN = 'return';
export const AUTHSIGNIN = 'authSingIn';
export const AUTHLOGIN = 'authLogIn';
export const REFRESHTOKEN = 'refreshToken';
export const GET_CRM_USER = 'getUserCRM';
export const GETUSER = 'getUser';
export const FILTER = 'filters';
export const TAGS = 'tags';
export const DELETE_CRM = 'deleteCRM';
export const SEND_CRM = 'sendCRM';
export const GET_ALL_USERS = 'getAllUsers';
export const DELETE_USER = 'deleteUser';
export const EDIT_USER = 'editUser';
export const CREATE_USER = 'createUser';
export const USERS = 'users';
export const GET_BOOKSTAT_PROCESSING_STATUS = 'getBookstatProcessingStatus';
export const SEARCH_BY_CONDITIONS = 'search';
export const MANUALLY_ADDED = 'manuallyadded';
export const POPULAR = 'popular';
export const RISING_STARS = 'risingStars';
export const TRENDING = 'trending';
export const AUTHORS = 'authors';
export const PODIUMAUTHORS = 'podiumAuthors';
export const ALL_TITLES_RR = 'alltitlesRR';
export const WATCHLIST_RR = 'watchlistRR';
export const CONTACTED_RR = 'contactedRR';
export const PENDING_EXCLUSION_RR = 'pendingExclusionRR';
export const ALL_EXCLUDED_RR = 'excludedRR';
export const SENT_TO_CRM_RR = 'senttocrmRR';
export const MUTED_AUTHORS_RR = 'mutedAuthorsRR';
export const ROYAL_ROAD_TITLE = 'royalroadtitle';
export const ROYAL_ROAD_AUTHOR = 'royalroadauthor';
export const PODIUM_TITLES_RR = 'podiumtitlesRR';
export const TWITTER = 'twitter';
export const AMAZON = 'amazon';
export const AUTHOR_TAGS = 'authortags';
export const DAILY_RANK_AUDIO_BOOKS = 'dailyRankAudioBooks';
export const DAILY_RANK_EBOOKS = 'dailyRankEbooks';
export const DAILY_RANK_CATALOGUE = 'dailyRankCatalogue';
export const DAILY_RANK_PRINT = 'dailyRankPrint';
export const SAVED_SEARCHES = 'savedSearches';
export const ALL_TITLES_BST = 'alltitlesbst';
export const CLOSED_DEAL_NOTES = 'closedDealNotes';
export const POPULAR_AO3 = 'popularAO3';
export const EXPLAIN_PREDICTION = 'explainPrediction';
export const TABLEAU_EMBED_TOKEN = 'TABLEAU_EMBED_TOKEN';
export const WATCHLIST_AO3 = 'watchlistAO3';
export const CONTACTED_AO3 = 'contactedAO3';
export const PENDING_EXCLUSION_AO3 = 'pendingExclusionAO3';
export const ALL_EXCLUDED_AO3 = 'excludedAO3';
export const PODIUM_TITLES_AO3 = 'podiumtitlesAO3';
export const SENT_TO_CRM_AO3 = 'senttocrmAO3';
export const MUTED_AUTHORS_AO3 = 'mutedAuthorsAO3';
export const GET_CONFIG = 'getconfig';
export const AO3 = 'ao3';

export const SOURCE = {
  'bookstat': '/bookstat',
  'royal-road': '/royal-road',
  'daily-rank': '/daily-rank',
  'ao3': '/ao3'
};

export const BookstatEndpoints = {
  [ALL_EXCLUDED]: '/all-excluded',
  [ALL_NEW_TITLE]: '/all-new-titles',
  [HOT_TITLES]: '/hot-titles',
  [TOP_POD_TITLES]: '/top-pod-titles',
  [WATCHLIST]: '/watchlist',
  [CONTACTED]: '/contacted',
  [MANUALLY_ADDED]: '/manually-added-titles',
  [PENDING_EXCLUSION]: '/pending-exclusion',
  [PODIUM_SALES]: '/podium-sales',
  [PODIUM_TITLES]: '/podium-titles',
  [SEND_TO_CRM]: '/sent-to-crm',
  [BOOKSTAT_DATA]: '/bookstat-data',
  [COMPETITORS]: '/competitors',
  [ALL_TITLES_BST]: '/all-titles-bst',
  [MUTED_AUTHORS]: '/muted-authors'
};

export const RoyalRoadEndpoints = {
  [POPULAR]: '/popular',
  [RISING_STARS]: '/rising-stars',
  [TRENDING]: '/trending',
  [AUTHORS]: '/authors',
  [PODIUMAUTHORS]: '/podium-authors',
  [WATCHLIST_RR]: '/watchlist',
  [CONTACTED_RR]: '/contacted',
  [ALL_EXCLUDED_RR]: '/all-excluded',
  [PENDING_EXCLUSION_RR]: '/pending-exclusion',
  [ALL_TITLES_RR]: '/all-new-titles',
  [SENT_TO_CRM_RR]: '/sent-to-crm',
  [PODIUM_TITLES_RR]: '/podium-titles',
  [MUTED_AUTHORS_RR]: '/muted-authors'
};

export const DailyRankEndpoints = {
  [DAILY_RANK_EBOOKS]: '/ebooks',
  [DAILY_RANK_AUDIO_BOOKS]: '/audio-books',
  [DAILY_RANK_CATALOGUE]: '/catalogue',
  [DAILY_RANK_PRINT]: '/print'
};

export const AO3Endpoints = {
  [POPULAR_AO3]: '/popular',
  [WATCHLIST_AO3]: '/watchlist',
  [CONTACTED_AO3]: '/contacted',
  [PENDING_EXCLUSION_AO3]: '/pending-exclusion',
  [ALL_EXCLUDED_AO3]: '/all-excluded',
  [PODIUM_TITLES_AO3]: '/podium-titles',
  [SENT_TO_CRM_AO3]: '/sent-to-crm',
  [MUTED_AUTHORS_AO3]: '/muted-authors'
};

const Endpoints = {
  [AUTHSIGNIN]: '/auth/sign-in',
  [AUTHLOGIN]: '/auth/custom-login',
  [CREATE_USER]: '/create-users',
  [DELETE_CRM]: 'hubspot-delete',
  [DELETE_USER]: '/delete-users',
  [DELETE]: '/deleted',
  [BLOCKAUTHOR]: '/block-authors',
  [MUTEAUTHOR]: '/mute-authors',
  [UNMUTEAUTHOR]: '/unmute-authors',
  [EDIT_USER]: '/update-users',
  [FILTER]: '/filters',
  [GET_ALL_USERS]: '/get-all-users',
  [GET_CRM_USER]: '/get-all-users/enable_crm_rights=true',
  [GETUSER]: '/get-user-details',
  [REFRESHTOKEN]: '/auth/refresh-tokens',
  [RETURN]: '/return',
  [SEARCH_BY_CONDITIONS]: 'search',
  [SEND_CRM]: 'hubspot-send',
  [TAGS]: '/tags',
  [USERS]: '/users',
  [ROYAL_ROAD_TITLE]: 'https://www.royalroad.com/fiction/',
  [ROYAL_ROAD_AUTHOR]: 'https://www.royalroad.com/profile/',
  [TWITTER]: 'https://twitter.com/',
  [AMAZON]: 'https://www.amazon.com/dp/',
  [AO3]: 'https://archiveofourown.org/works/',
  [AUTHOR_TAGS]: '/author-tags',
  [SAVED_SEARCHES]: '/my-saved-searches',
  [GET_BOOKSTAT_PROCESSING_STATUS]: '/bookstat-status',
  [CLOSED_DEAL_NOTES]: '/closed-deal-notes',
  [EXPLAIN_PREDICTION]: '/explain-prediction',
  [TABLEAU_EMBED_TOKEN]: '/tableau-embed-token',
  [GET_CONFIG]: '/config',
  ...BookstatEndpoints,
  ...RoyalRoadEndpoints,
  ...DailyRankEndpoints,
  ...AO3Endpoints
};

export const NAVIGABLE_PATHS: Record<string, string> = {
  'All New Titles': 'all-new-titles',
  'Hot Titles': 'hot-titles',
  Watchlist: 'watchlist',
  Contacted: 'contacted',
  'Pending Exclusion': 'pending-exclusion',
  'Sent To CRM': 'sent-to-crm'
};

export const ENDPOINT_TO_TAB_NAME: Record<string, string> = {
  ...Object.fromEntries(
    Object.entries(NAVIGABLE_PATHS).map(([tabName, endpoint]) => [endpoint, tabName])
  ),
  'all-excluded': 'Excluded',
  'podium-titles': 'Podium Titles',
  'muted-authors': 'Muted Authors'
};

export default Endpoints;